var map = {
	"./SmartIot_Vertical_App.png": 741,
	"./SmartRoute_Vertical_App.png": 742,
	"./SmartStock_Vertical_App.png": 743,
	"./SmartSuite_Vertical_App.png": 744,
	"./SmartTruck_Vertical_App.png": 745,
	"./SmartWork_Vertical_App.png": 746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 740;